module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn( dashboardTitle ))
    ; __append("</h1>\r\n        </div>\r\n    </div>\r\n\r\n    <ol class=\"breadcrumb\">\r\n        ")
    ; 
        var count = breadcrumbs.length;
        var crumbCount = 0;
        _.forEach(breadcrumbs, function (crumb) {
            crumbCount++;
            if (crumbCount === count) {
            
    ; __append("\r\n            <li>")
    ; __append(escapeFn( crumb.name ))
    ; __append("</li>\r\n            ")
    ;  } else { 
    ; __append("\r\n            <li><a href=\"")
    ; __append(escapeFn( crumb.route ))
    ; __append("\" id=\"")
    ; __append(escapeFn( crumb.id ))
    ; __append("\">")
    ; __append(escapeFn( crumb.name ))
    ; __append("</a></li>\r\n            ")
    ; 
            }
        });
    ; __append("\r\n    </ol>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-5\">\r\n        <h2>Details</h2>\r\n        <div class=\"row nopadding-l\">\r\n                <div class=\"col-md-2\"><label>Name</label></div>\r\n                <div class=\"col-md-10\"><input type=\"text\" name=\"Name\" value=\"")
    ; __append(escapeFn( updatedUserPositionDetails.Name))
    ; __append("\"> </div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-2\"><label>Description</label></div>\r\n            <div class=\"col-md-10\">\r\n                <textarea rows=\"4\" cols=\"20\" name=\"Description\"\r\n                          style=\"min-height: auto !important; height: auto !important;\">")
    ; __append(escapeFn( updatedUserPositionDetails.Description))
    ; __append("</textarea>\r\n            </div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-2\"><label>Active</label></div>\r\n            <div class=\"col-md-10\">\r\n                <input type=\"checkbox\" name=\"IsActive\"\r\n                        ")
    ; __append(escapeFn( updatedUserPositionDetails.IsActive.toLowerCase()==='true'? 'checked' : ''))
    ; __append(">\r\n                     </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-7\">\r\n        <h2>User</h2>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12\">\r\n                <input type=\"text\" name=\"userMember\" value=\"")
    ; __append(escapeFn(updatedUserPositionDetails.MembersXML.Members.User['@caption']))
    ; __append("\">\r\n            </div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12\">\r\n                <input type=\"button\" class=\"btn btn-default\" name=\"selectUser\" id=\"selectUser\" value=\"Select\"/>\r\n                <input type=\"button\" class=\"btn btn-default\" name=\"removeUser\" id=\"removeUser\" value=\"Remove\"/>\r\n            </div>\r\n           \r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div id=\"noChangesSection\" class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"deletePosition\" value=\"Delete\"/>\r\n    </div>\r\n</div>\r\n\r\n<div id=\"changesSection\" class=\"row hide\">\r\n    <div class=\"col-md-12\">\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"applyChanges\" value=\"Apply Changes\"/>\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"cancel\" value=\"Cancel\">\r\n    </div>\r\n  \r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <h2>Settings Help</h2>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_QUICK_START ))
    ; __append("\" target=\"_blank\">Getting Started</a></div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_ADMIN_PF ))
    ; __append("\" target=\"_blank\">Administering and Integrating PerfectApps</a></div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_ADMIN_USERS ))
    ; __append("\" target=\"_blank\">Administering Users, User Groups and Positions</a></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}